






























import { Vue, Component } from 'vue-property-decorator';
import { BRAND_NAME, CHRNCL_SOCIAL } from '../../common/brand.config';

@Component
export default class PublicBottomFooter extends Vue {
  CHRNCL_SOCIAL = CHRNCL_SOCIAL;

  BRAND_NAME = BRAND_NAME;
}
